"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _HBMenuItemOld = _interopRequireDefault(require("./HBMenuItemOld"));
var _HBPopover = _interopRequireDefault(require("../HBPopover/HBPopover"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var HBMenuOld = function HBMenuOld(_ref) {
  var target = _ref.target,
    menuItems = _ref.menuItems,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
    _ref$openTrigger = _ref.openTrigger,
    openTrigger = _ref$openTrigger === void 0 ? 'click' : _ref$openTrigger,
    className = _ref.className,
    _ref$withArrow = _ref.withArrow,
    withArrow = _ref$withArrow === void 0 ? true : _ref$withArrow,
    targetContainerStyle = _ref.targetContainerStyle,
    _ref$shouldSupportOve = _ref.shouldSupportOverflowHidden,
    shouldSupportOverflowHidden = _ref$shouldSupportOve === void 0 ? false : _ref$shouldSupportOve,
    _ref$stopPropagationO = _ref.stopPropagationOnTargetClick,
    stopPropagationOnTargetClick = _ref$stopPropagationO === void 0 ? false : _ref$stopPropagationO,
    customStyle = _ref.customStyle,
    offsetX = _ref.offsetX,
    offsetY = _ref.offsetY,
    onOpenChange = _ref.onOpenChange,
    forceClose = _ref.forceClose;
  return /*#__PURE__*/_react["default"].createElement(_HBPopover["default"], {
    withArrow: withArrow,
    target: target,
    className: className,
    placement: placement,
    offsetX: offsetX,
    offsetY: offsetY,
    theme: "menu",
    openTrigger: openTrigger,
    shouldSupportClickOutside: true,
    shouldSupportOverflowHidden: shouldSupportOverflowHidden,
    stopPropagationOnTargetClick: stopPropagationOnTargetClick,
    customStyle: _objectSpread({
      minWidth: '200px'
    }, customStyle),
    onOpenChange: onOpenChange
    // @ts-ignore
    ,
    targetContainerStyle: _objectSpread({
      display: 'flex'
    }, targetContainerStyle),
    testId: "menu-old",
    forceClose: forceClose
  }, function (setIsOpen) {
    return menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(_HBMenuItemOld["default"], {
        key: index.toString(),
        item: item,
        closeMenu: function closeMenu() {
          return setIsOpen({
            newIsOpen: false
          });
        }
      });
    });
  });
};
var _default = exports["default"] = HBMenuOld;
//# sourceMappingURL=HBMenuOld.js.map